import { Component, OnInit, ViewChild } from '@angular/core';
import { ModulesManagerService } from './classes/Module/modules-manager.service';
import { UserService } from './classes/User/user.service';
import { MenuNaviService } from './utils/menu-navi.service';
import { TraductionService } from './utils/traduction.service';
import { Platform } from '@ionic/angular';
import { SQLiteService } from './services/sqlite.service';
import { Router } from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  public isWeb: boolean = false;

  @ViewChild('notAvaible') notAvaibleAlert;
  @ViewChild("updateAlerte") updateAlerte;
  constructor(private platform: Platform, private sqlite: SQLiteService, public menuNavi: MenuNaviService, public traduction: TraductionService, public user: UserService, public manager: ModulesManagerService, private router: Router) {
    if (!window.localStorage.internalKeys) window.localStorage.internalKeys = "[]"

    if (typeof String.prototype["replaceAll"] == "undefined") {
      String.prototype["replaceAll"] = function (match, replace) {
        return this.replace(new RegExp(match, 'g'), () => replace);
      }
    }

    Date.prototype["getFromFormat"] = function (format) {
      var yyyy = this.getFullYear().toString();
      format = format.replace(/yyyy/g, yyyy)
      var mm = (this.getMonth() + 1).toString();
      format = format.replace(/mm/g, (mm[1] ? mm : "0" + mm[0]));
      var dd = this.getDate().toString();
      format = format.replace(/dd/g, (dd[1] ? dd : "0" + dd[0]));
      var hh = this.getHours().toString();
      format = format.replace(/hh/g, (hh[1] ? hh : "0" + hh[0]));
      var ii = this.getMinutes().toString();
      format = format.replace(/ii/g, (ii[1] ? ii : "0" + ii[0]));
      var ss = this.getSeconds().toString();
      format = format.replace(/ss/g, (ss[1] ? ss : "0" + ss[0]));
      return format;
    };
    window.localStorage.Href = window.location.href
    this.manager.Tool.DeviceReady().then(() => {
      this.manager.Navi.removeSpalsh()
      this.manager.hideStatusBar()

      this.manager.Updater.setPopupAlerte(this.updateAlerte)
      this.manager.Ws.Popup = this.notAvaibleAlert;
    })
    this.initializeApp()
    App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
      if (event.url) {
        this.manager.Ws.OnFirstLaunch(() => {
          window.localStorage.Href = event.url
          this.manager.Navi.verifyUrl()
          this.manager.Navi.closeMenu()
        })
      }

    })
    this.manager.Navi.verifyUrl()
    this.manager.Navi.closeMenu()
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      this.sqlite.initializePlugin().then(async (ret) => {
        if (this.sqlite.platform === "web") {
          this.isWeb = true;
          await this.sqlite.initWebStore();
        }

      });
    });
  }
  public async ngOnInit() {
    //this.initializeApp()
  }

}
